"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgFaceWink = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm1.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM7 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm.4 4.2a1 1 0 0 1 1.397.196l.005.006.033.041a4.945 4.945 0 0 0 .815.748c.578.42 1.376.81 2.35.81.975 0 1.772-.39 2.35-.81a4.945 4.945 0 0 0 .815-.748l.034-.041.004-.006A1 1 0 0 1 16.8 14.6l-.103.129c-.059.07-.142.164-.248.276a6.951 6.951 0 0 1-.923.804c-.798.58-2 1.191-3.526 1.191-1.525 0-2.728-.61-3.526-1.191a6.949 6.949 0 0 1-1.17-1.08A4.25 4.25 0 0 1 7.2 14.6a1 1 0 0 1 .2-1.4Z", fill: "currentColor" }) }))); };
exports.default = SvgFaceWink;
